/**
 * src/api/licitaciones.js
 * El mapeo licitación de Convenio Marco → tienda del portal.
 *
 * 🔴 **La tabla que hay detrás es GLOBAL y acumulativa entre tenants.** No es
 * configuración de un cliente: una fila equivocada la heredan todos y nadie
 * vuelve a mirarla. Por eso `app/services/sonda_convenios.py` —que sabe de sobra
 * lo que ha medido— se prohíbe a sí misma escribirla, y por eso adoptar sigue
 * siendo un acto humano explícito.
 *
 * ⚠️ **`tienda: null` NO es «vacío»: es un veredicto.** Significa «medida y
 * confirmada como NO soportada (otro portal), para no re-sondearla». Quien llame
 * a esto tiene que saber la diferencia, porque el backend no puede distinguirla:
 * `LicitacionTiendaUpdate.tienda` es `Optional[str] = None`, así que un `PUT` con
 * el cuerpo vacío marca la licitación como NO soportada **sin decir nada**. Por
 * eso `adoptarLicitacion` exige los dos argumentos y no tiene valor por defecto:
 * el que llama elige, siempre.
 */
import api from './client'

/** Las filas ya escritas. `tienda: null` es un veredicto, no un hueco. */
export const getLicitaciones = () =>
  api.get('/admin/licitaciones').then(r => (Array.isArray(r.data) ? r.data : []))

/**
 * Crea o corrige una fila. El backend le pone `origen: "admin"`.
 *
 * `tienda` es el slug, o `null` para declararla NO soportada. No hay tercer
 * valor: no pasar nada sería pedir lo segundo sin quererlo.
 */
export const adoptarLicitacion = (licitacion, tienda) =>
  api.put(`/admin/licitaciones/${encodeURIComponent(licitacion)}`, { tienda })
    .then(r => r.data)

/**
 * El catálogo de convenios CON su licitación y su título de OCDS — la EVIDENCIA.
 *
 * ⚠️ No sirve el `/convenios` público que usa `api/convenios.js`: ese recorta a
 * `slug`, `nombre` y `url_base` a propósito, y se deja fuera justo los dos campos
 * que hacen que adoptar sea reconocer en vez de teclear de memoria. Éste es el de
 * admin, que devuelve el catálogo entero.
 */
export const getConveniosConLicitacion = () =>
  api.get('/admin/panel/convenios').then(r => r.data?.convenios ?? [])
